import React, { useEffect, useContext } from "react";
import useState from "react-usestateref";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Select from "react-select";
import { Link } from "react-router-dom";
import FreeImage from "../assests/freeweb.webp";
import PreImage from "../assests/white_img.webp";
import { initializePaddle, getPaddleInstance } from "@paddle/paddle-js";
import ProImage from "../assests/yelllow_img.webp";
import { ScaleLoader } from "react-spinners";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import authService from "../services/authservices";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";
import { UserContext } from "../contexts/UserContext";
import i18n from "../translate/i18n";

const customStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "#f9f9f9",
    border: "1px solid #ccc",
    padding: "4px",
  }),
  option: (styles, { isFocused }) => ({
    ...styles,
    color: "#fff",
    backgroundColor: isFocused ? "#292b31" : "#181a20",
    cursor: "pointer",
  }),
  singleValue: (styles) => ({
    ...styles,
    color: "#000",
  }),
};

// const priceMap = {
//   "Elite Trader": {
//     USD: {
//       priceId: "pri_01jzwsg5ygvvehh8hs3gaer7dn",
//       cost: 39,
//     },
//     EUR: {
//       priceId: "pri_01jzwrmbk5jvbr1tym76jzh42t",
//       cost: 33,
//     },
//   },
//   "Promium": {
//     USD: {
//       priceId: "pri_01jzwsee9mqtp4212p12j4ncb2",
//       cost: 21,
//     },
//     EUR: {
//       priceId: "pri_01jzwrhq44v6242avpzrx6rsze",
//       cost: 18,
//     },
//   },
//   "Premium": {
//     USD: {
//       priceId: "pri_01jzwscfekp2ydw9e15arv9pxv",
//       cost: 31,
//     },
//     EUR: {
//       priceId: "pri_01jzwrek4h394kp4vmwtr24496",
//       cost: 27,
//     },
//   },
// };

const priceMap = {
  "Elite Trader": {
    USD: {
      priceId: "pri_01jzwsg5ygvvehh8hs3gaer7dn",
      cost: 39.01,
    },
    EUR: {
      priceId: "pri_01jzwrmbk5jvbr1tym76jzh42t",
      cost: 33.7,
    },
    // SGD: {
    //   priceId: "pri_01k6fagrehar6vebqp1jayczqs",
    //   cost: 18.0,
    // },
    // CNY: {
    //   priceId: "pri_01k6fafsp3yzmcyv3j7jtt1hen",
    //   cost: 22.0,
    // },
    // THB: {
    //   priceId: "pri_01k6faep4jbc7dx9ymjs3fy9b2",
    //   cost: 26.0,
    // },
    // TWD: {
    //   priceId: "pri_01k6fadf8s59tktssy7va7afz8",
    //   cost: 27.0,
    // },
  },
  Promium: {
    USD: {
      priceId: "pri_01jzwsee9mqtp4212p12j4ncb2",
      cost: 31.0,
    },
    EUR: {
      priceId: "pri_01jzwrhq44v6242avpzrx6rsze",
      cost: 26.78,
    },
    // SGD: {
    //   priceId: "pri_01k6fb9n117wstcs7jzaa2t57q",
    //   cost: 37.0,
    // },
    // CNY: {
    //   priceId: "pri_01k6fb8ns4qt34qz2zv9x2bpp1",
    //   cost: 32.0,
    // },
    // THB: {
    //   priceId: "pri_01k6fb7sev9r1ym289jyrca8cr",
    //   cost: 28.0,
    // },
    // TWD: {
    //   priceId: "pri_01k6fb6p3ss4kcz7y152ny4knv",
    //   cost: 26.0,
    // },
  },
  Premium: {
    USD: {
      priceId: "pri_01jzwscfekp2ydw9e15arv9pxv",
      cost: 21.0,
    },
    EUR: {
      priceId: "pri_01jzwrek4h394kp4vmwtr24496",
      cost: 18.14,
    },
    // THB: {
    //   priceId: "pri_01k6fbj6ve3ph86nwhb65emga3",
    //   cost: 28.0,
    // },
    // CNY: {
    //   priceId: "pri_01k6fbhcg342g9f2cc9fdw9vcg",
    //   cost: 24.0,
    // },
    // SGD: {
    //   priceId: "pri_01k6fbgg91zt4rmtws6n44xd3b",
    //   cost: 31.0,
    // },
    // TWD: {
    //   priceId: "pri_01k6fbk36044ycz01pn3119h12",
    //   cost: 19.0,
    // },
  },
};

const Upgrade = () => {
  const [coinType, setCoinType, coinTyperef] = useState("usdt");
  const { t } = useTranslation();

  const [i18nextLngs, seti18nextLngs] = useState(
    localStorage.getItem("i18nextLng") || "en" || "et" || "fi"
  );
  const { i18nextLng } = useContext(UserContext);
  useEffect(() => {
    if (i18nextLng === "en") {
      i18n.changeLanguage(i18nextLngs);
      document.documentElement.lang = i18nextLngs;
      localStorage.setItem("i18nextLng", i18nextLngs);
    }
  }, [i18nextLng]);

  const options = [
    {
      value: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
      label: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
    },
    {
      value: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
      label: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
    },
    {
      value: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
      label: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
    },
  ];

  useEffect(() => {
    getPlan();
    getPlanDetails();
  }, [0]);

  const [getplan, setGetplan] = useState([]);
  const [planDetails, setPlanDetails] = useState([]);
  const [pageLoader, setpageLoader] = useState(false);
  const [show, setShow] = useState(false);
  const [fiatviashow, setFiatviashow] = useState(false);
  const [freemiumActive, setFreemiumActive] = useState(null);
  const [premiumActive, setPremiumActive] = useState(null);
  const [promiumActive, setPromiumActive] = useState(null);
  const [planLoader, setplanLoader] = useState(false);
  const [loading, setLoading] = useState(true);
  const [selectedCost, setSelectedCost] = useState(null);
  const [paddle, setPaddle] = useState(null);

  const [premiumContent, setPremiumContent] = useState(null);
  const [Freeplan, setFreeplan] = useState(false);
  const [eliteActive, setEliteActive] = useState(null);
  // console.log(eliteActive, "eliteActive");
  const [discountCode, setdiscountCode] = useState("");
  const [discountAmount, setdiscountAmount] = useState("");
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [selectedPriceId, setSelectedPriceId] = useState(null);
  // console.log(selectedPriceId, "selectedPriceId");

  useEffect(() => {
    const href = window.location.pathname;
    const url = href.split("upgrade/")[1];
    // console.log(url);
    setdiscountCode(url ? url : "");
  }, []);

  useEffect(() => {
    const loadPaddle = async () => {
      try {
        await initializePaddle({
          environment: "sandbox",
          token: "test_bfda518ec13124ce67f4cd776df",
          eventCallback: async function (event) {
            console.log(event, "event=====");
            if (event.name === "checkout.completed") {
              // const paddle = getPaddleInstance();
              // paddle?.Checkout.close();
              setShow(false);
              setFiatviashow(false);
              setSelectedPriceId(null);
              setSelectedCurrency(null);
              setPremiumContent(null);
              showsuccessToast("Payment completed successfully");
              await getPlan();
              await fetchPlanWithRetry(10, 500);
            }
          },
        });

        const paddleInstance = getPaddleInstance();

        if (paddleInstance) {
          setPaddle(paddleInstance);
        } else {
          toast.error("Failed to get Paddle instance");
        }
      } catch (error) {
        console.error("Paddle initialization error:", error);
        toast.error("Error initializing payment system.");
      }
    };

    loadPaddle();
  }, []);

  const getPlan = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await authService.getPlan(token);
      if (response.status) {
        setGetplan(response.data);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const handleCurrencyChange = (selectedOption) => {
    const currency = selectedOption.value;
    setSelectedCurrency(currency);

    const selectedPlan = premiumContent?.subscriptionName;
    const priceDetails = priceMap[selectedPlan]?.[currency];
    console.log(priceDetails, "priceDetails==");

    if (selectedPlan && priceDetails) {
      setSelectedPriceId(priceDetails.priceId);
      setSelectedCost(priceDetails.cost);
    }
  };

  const getPlanDetails = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await authService.getPlanDetails(token);
      setLoading(false);

      if (response.data && Array.isArray(response.data)) {
        const activePlans = {
          freemium: false,
          premium: false,
          promium: false,
          elite: false,
        };
        // console.log(response.data, "response.data");
        response.data.forEach((plan) => {
          if (plan.subscriptionName === "Freemium" && plan.isActive) {
            activePlans.freemium = true;
          } else if (plan.subscriptionName === "Premium" && plan.isActive) {
            activePlans.premium = true;
          } else if (plan.subscriptionName === "Promium" && plan.isActive) {
            activePlans.promium = true;
          } else if (
            plan.subscriptionName === "Elite Trader" &&
            plan.isActive
          ) {
            activePlans.elite = true;
          }
        });

        // Update state at once for better performance
        setFreemiumActive(activePlans.freemium);
        setPremiumActive(activePlans.premium);
        setPromiumActive(activePlans.promium);
        setEliteActive(activePlans.elite);

        const freemiumActivated = response.data.some(
          (plan) =>
            plan.subscriptionName === "Freemium" &&
            plan.isFreemiumActivated === true
        );

        localStorage.setItem("freemiumActivated", freemiumActivated);
        setPlanDetails(response.data);
        setFreeplan(response.free_plan);
      } else {
        setPlanDetails([]);
        localStorage.setItem("freemiumActivated", false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching plan details:", error);
    }
  };

  const fetchPlanWithRetry = async (retries = 10, delay = 500) => {
    for (let i = 0; i < retries; i++) {
      const result = await getPlanDetails();
      if (result && result.length > 0) {
        return result;
      }
      await new Promise((res) => setTimeout(res, delay));
    }
    return null;
  };

  const showsuccessToast = (message) => {
    toast.dismiss();
    toast.success(
      <div className="toast-ml">
        <h4 className="toast-title">Success!</h4>
        <p className="toast-message">{message}</p>
      </div>
    );
  };

  const showerrorToast = (message) => {
    toast.dismiss();
    toast.error(
      <div className="toast-ml">
        <h4 className="toast-title">Error!</h4>
        <p className="toast-message">{message}</p>
      </div>
    );
  };

  const handleClose = () => {
    setShow(false);
    setPremiumContent(null);
  };
  const handleCloseFiat = () => {
    setShow(false);
    setFiatviashow(false);
    setSelectedPriceId(null);
    setSelectedCurrency(null);
    setPremiumContent(null);
  };

  const handleShow = async (planName, subscription) => {
    // console.log(subscription, "subscription");
    switch (planName) {
      case "Premium":
        setPremiumContent(subscription);
        break;
      case "Freemium":
        setPremiumContent(subscription);
        break;
      case "Promium":
        setPremiumContent(subscription);
        break;
      case "Elite Trader":
        setPremiumContent(subscription);
        break;
      default:
        break;
    }
    setShow(true);
    if (discountCode) {
      const getDiscount = await authService.getDiscountData(discountCode);
      if (getDiscount.status) {
        setdiscountAmount(getDiscount.data);
      }
    }
  };

  const FiatviaUpgrade = async (data) => {
    // console.log(data, "data====");
    setShow(false);
    setFiatviashow(true);
  };
  // const ConfirmFiatUpgrade = async (data) => {
  //   if (!selectedCurrency || !selectedPriceId) {
  //     showerrorToast("Please select a currency");
  //     return;
  //   }

  //   const userEmail = localStorage.getItem("useremail");

  //   if (!userEmail) {
  //     showerrorToast("User email not found. Please log in again.");
  //     return;
  //   }

  //   if (!paddle) {
  //     showerrorToast("Payment gateway not ready. Please try again later.");
  //     return;
  //   }

  //   setLoading(true);

  //   try {
  //     await paddle.Checkout.open({
  //       items: [{ priceId: selectedPriceId, quantity: 1 }],
  //       customer: {
  //         email: userEmail,
  //       },
  //       customData: {
  //         subid: data._id,
  //         email: userEmail,
  //       },
  //     });

  //     // console.log("Submitted Data:", data);
  //     setShow(false);
  //     setFiatviashow(false);
  //   } catch (err) {
  //     console.error("Paddle checkout error:", err);
  //     showerrorToast("Payment failed. Please try again.");
  //   }

  //   setLoading(false);
  // };


  const ConfirmFiatUpgrade = async (data) => {
  if (!selectedCurrency) {
    showerrorToast("Please select a currency");
    return;
  }

  const userEmail = localStorage.getItem("useremail");

  if (!userEmail) {
    showerrorToast("User email not found. Please log in again.");
    return;
  }

  setLoading(true);

  try {
    const payload = {
      fiatAmount: selectedCost,          
      subid:premiumContent._id,
      fiatCurrency: selectedCurrency,     
    };

    const response = await authService.planUpgradeStripe(payload);

    if (response.status && response.checkoutUrl) {
      window.location.href = response.checkoutUrl;
    } else {
      showerrorToast("Unable to create Stripe checkout session");
    }

    setShow(false);
    setFiatviashow(false);

  } catch (err) {
    console.error("Stripe checkout error:", err);
    showerrorToast("Payment failed. Please try again.");
  }

  setLoading(false);
};


  const PlanUpgrade = async (data) => {
    try {
      setLoading(true);
      var obj = {
        subid: data._id,
        discountAmount: discountAmount,
        discountCode: discountCode,
      };
      // console.log(obj);
      const response = await authService.planUpgrade(obj);
      if (response.status) {
        setLoading(false);
        showsuccessToast(response.Message);
        getPlanDetails();
      } else {
        showerrorToast(response.Message);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      // console.log(error, "-----------------");
    }
    setShow(false);
  };
  const [faqs, setFaqs] = useState({});

  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const response = await authService.getFaq();
        if (response.status) {
          const withdrawFaqs = response.data.filter(
            (faq) => faq.type === "Upgrade"
          );
          setFaqs(withdrawFaqs);
        } else {
          console.error("Failed to fetch FAQs");
        }
      } catch (error) {
        console.error("Error fetching FAQs:", error);
      }
    };

    fetchFaqs();
  }, []);

  const capitalizeFirstLetter = (string) => {
    if (!string) return "";
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  const SubscriptionCard = ({ subscription, freemiumActive }) => {
    if (!subscription) {
      return (
        <div className="no_plan_message">
          <p>No plans available at the moment.</p>
        </div>
      );
    }
    switch (subscription.subscriptionName) {
      case "Freemium":
        return (
          <div className="free_upgradesec">
            <div className="free_version_section">
              {freemiumActive && <div className="activated_tag">Activated</div>}
              <img src={FreeImage} alt="Loading..." />
              <h5>{capitalizeFirstLetter(subscription.subscriptionName)}</h5>
              <p>Bots Strategies</p>
              <p className="free_intra">{subscription.Strategies}</p>
              <h1>Free</h1>
              {/* <p style={{visibility:'hidden'}} className="free_tag">Free for 6 months </p> */}
              <p className="free_tag">Free for {subscription.subdays} Days </p>
              <div className="activate_btn">
                <button
                  disabled={freemiumActive || Freeplan}
                  onClick={() => handleShow("Freemium", subscription)}
                >
                  Activate
                </button>
              </div>
              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list">Exchanges:</span>{" "}
                    {capitalizeFirstLetter(subscription.Exchanges)}
                  </p>
                </div>
              </div>
              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                {/* <div className="free_details_list">
                  <p><span className="header_details_list">Profit Split:</span> {subscription.SecondDistribution.user}(Users): {subscription.SecondDistribution.referral}(Referrals): {subscription.SecondDistribution.ipf}(IPF) + {subscription.SecondDistribution.admin}(Admins)</p>
                </div> */}
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list">Profit Split:</span>{" "}
                    {/* {subscription.SecondDistribution.referral}(Referrals):{" "}
                    {subscription.SecondDistribution.ipf}(IPF) +{" "} */}
                    {subscription.SecondDistribution.user}(Users) +{" "}
                    {subscription.SecondDistribution.admin}(Admin)
                  </p>
                </div>
              </div>
              {/* <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list">
                      Referral one time reward ({subscription.subscriptionCurrency}):
                    </span>{" "}
                    {subscription.referral_first}
                  </p>
                </div>
              </div>

              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list">
                      Referral reward for recurring payments (%):
                    </span>{" "}
                    {subscription.referral_percentage}
                  </p>
                </div>
              </div> */}
              {/* <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list">
                      Own Account Use:
                    </span>{" "}
                    {capitalizeFirstLetter(subscription.OwnAccountUse)}
                  </p>
                </div>
              </div> */}
              {/* <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list">
                      Minimum Balance Req To Trade:
                    </span>{" "}
                    {subscription.minbalancereq}
                  </p>
                </div>
              </div> */}
              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list">
                      Minimum Fuel Balance Required:
                    </span>{" "}
                    {subscription.min_fuel}
                  </p>
                </div>
              </div>
              {/* <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list">
                      Referral Withdrawal:
                    </span>{" "}
                    {capitalizeFirstLetter(subscription.Refferalwithdraw)}
                  </p>
                </div>
              </div>
              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list">
                      Withdrawal Time For All User, Referral:
                    </span>{" "}
                    {capitalizeFirstLetter(
                      subscription.Withdrawtimeforallrefferaluser
                    )}
                  </p>
                </div>
              </div> */}
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  const SubscriptionCardtwo = ({ subscription, premiumActive }) => {
    if (!subscription) {
      return (
        <div className="no_plan_message">
          <p>No plans available at the moment.</p>
        </div>
      );
    }
    switch (subscription.subscriptionName) {
      case "Premium":
        return (
          <div className="perimium_upgradesec">
            <div className="premium_version_section">
              {premiumActive && (
                <div className="activated_tag_pre">Activated</div>
              )}
              <img src={PreImage} className="premium_img" alt="Loading..." />
              <h5>{capitalizeFirstLetter(subscription.subscriptionName)}</h5>
              <p>Bots Strategies</p>
              <p className="free_intra">{subscription.Strategies}</p>
              <h1>
                {parseFloat(subscription.subscriptionAmount).toFixed(2)}{" "}
                <span className="currency_name">
                  {subscription.subscriptionCurrency}
                </span>
                <span className="premium_cost">/month</span>
              </h1>
              <p className="free_tag" style={{ visibility: "hidden" }}>
                Free for {subscription.subdays} Months
              </p>
              <div className="activate_btn_white">
                <button
                  disabled={premiumActive}
                  onClick={() => handleShow("Premium", subscription)}
                >
                  Activate
                </button>
              </div>
              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pre">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  {/* <p>{capitalizeFirstLetter(subscription.Exchanges)}</p> */}
                  <p>
                    <span className="header_details_list_pre">Exchanges:</span>{" "}
                    {capitalizeFirstLetter(subscription.Exchanges)}
                  </p>
                </div>
              </div>
              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pre">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                {/* <div className="free_details_list">
                  <p><span className="header_details_list_pre">Profit Split:</span> {subscription.SecondDistribution.user}(Users): {subscription.SecondDistribution.referral}(Referrals): {subscription.SecondDistribution.ipf}(IPF) + {subscription.SecondDistribution.admin}(Admins)</p>
                </div> */}
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pre">
                      Profit Split:
                    </span>
                    {/* {subscription.SecondDistribution.referral}(Referrals):{" "}
                    {subscription.SecondDistribution.ipf}(IPF) +{" "} */}
                    {subscription.SecondDistribution.user}(Users) +{" "}
                    {subscription.SecondDistribution.admin}(Admin)
                  </p>
                </div>
              </div>

              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pre">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pre">
                      Referral one time reward (
                      {subscription.subscriptionCurrency}):
                    </span>{" "}
                    {subscription.referral_first}
                  </p>
                </div>
              </div>

              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pre">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pre">
                      Referral reward for recurring payments (%):
                    </span>{" "}
                    {subscription.referral_percentage}
                  </p>
                </div>
              </div>

              {/* <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pre">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pre">
                      Own Account Use:
                    </span>{" "}
                    {capitalizeFirstLetter(subscription.OwnAccountUse)}
                  </p>
                </div>
              </div> */}
              {/* <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pre">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pre">
                      Minimum Balance Req To Trade:
                    </span>{" "}
                    {subscription.minbalancereq}
                  </p>
                </div>
              </div> */}
              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pre">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pre">
                      Minimum Fuel Balance Required:
                    </span>{" "}
                    {subscription.min_fuel}
                  </p>
                </div>
              </div>
              {/* <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pre">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pre">
                      Referral Withdrawal:
                    </span>{" "}
                    {capitalizeFirstLetter(subscription.Refferalwithdraw)}
                  </p>
                </div>
              </div>
              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pre">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pre">
                      Withdrawal Time For All User, Referral:
                    </span>{" "}
                    {capitalizeFirstLetter(
                      subscription.Withdrawtimeforallrefferaluser
                    )}
                  </p>
                </div>
              </div> */}
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  const SubscriptionCardthree = ({ subscription, promiumActive }) => {
    if (!subscription) {
      return (
        <div className="no_plan_message">
          <p>No plans available at the moment.</p>
        </div>
      );
    }
    switch (subscription.subscriptionName) {
      case "Promium":
        return (
          <div className="extrapre_upgradesec">
            <div className="pro_version_section">
              {promiumActive && (
                <div className="activated_tag_pro">Activated</div>
              )}
              <img
                src={ProImage}
                className="premium_imgcost"
                alt="Loading..."
              />
              <h5>{capitalizeFirstLetter(subscription.subscriptionName)}</h5>
              <p>Bots Strategies</p>
              <p className="free_intra">{subscription.Strategies}</p>
              <h1>
                {parseFloat(subscription.subscriptionAmount).toFixed(2)}
                <span className="currency_name">
                  {" "}
                  {subscription.subscriptionCurrency}
                </span>
                <span className="premium_cost">/month</span>
              </h1>
              <p className="free_tag" style={{ visibility: "hidden" }}>
                <span className="free_plan_pro">Free</span> for{" "}
                {subscription.subdays} Months{" "}
              </p>
              <div className="activate_btn_pro">
                <button
                  disabled={promiumActive}
                  onClick={() => handleShow("Promium", subscription)}
                >
                  Activate
                </button>
              </div>
              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pro">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pro">Exchanges:</span>{" "}
                    {capitalizeFirstLetter(subscription.Exchanges)}
                  </p>
                  {/* <p>{capitalizeFirstLetter(subscription.Exchanges)}</p> */}
                </div>
              </div>
              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pro">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                {/* <div className="free_details_list">
                  <p><span className="header_details_list_pro">Profit Split:</span> {subscription.SecondDistribution.user}(Users): {subscription.SecondDistribution.referral}(Referrals): {subscription.SecondDistribution.ipf}(IPF) + {subscription.SecondDistribution.admin}(Admins)</p>
                </div> */}
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pro">
                      Profit Split:
                    </span>
                    {/* {subscription.SecondDistribution.referral}(Referrals):{" "}
                    {subscription.SecondDistribution.ipf}(IPF) +{" "} */}
                    {subscription.SecondDistribution.user}(Users) +{" "}
                    {subscription.SecondDistribution.admin}(Admin)
                  </p>
                </div>
              </div>

              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pro">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pro">
                      Referral one time reward (
                      {subscription.subscriptionCurrency}):
                    </span>{" "}
                    {subscription.referral_first}
                  </p>
                </div>
              </div>

              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pro">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pro">
                      Referral reward for recurring payments (%):
                    </span>{" "}
                    {subscription.referral_percentage}
                  </p>
                </div>
              </div>

              {/* <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pro">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pro">
                      Own Account Use:
                    </span>{" "}
                    {capitalizeFirstLetter(subscription.OwnAccountUse)}
                  </p>
                </div>
              </div> */}
              {/* <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pro">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pro">
                      Minimum Balance Req To Trade:
                    </span>{" "}
                    {subscription.minbalancereq}
                  </p>
                </div>
              </div> */}
              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pro">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pro">
                      Minimum Fuel Balance Required:
                    </span>{" "}
                    {subscription.min_fuel}
                  </p>
                </div>
              </div>
              {/* <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pro">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pro">
                      Referral Withdrawal:
                    </span>{" "}
                    {capitalizeFirstLetter(subscription.Refferalwithdraw)}
                  </p>
                </div>
              </div>
              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pro">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pro">
                      Withdrawal Time For All User, Referral:
                    </span>{" "}
                    {capitalizeFirstLetter(
                      subscription.Withdrawtimeforallrefferaluser
                    )}
                  </p>
                </div>
              </div> */}
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  const SubscriptionCardfour = ({ subscription, eliteActive }) => {
    if (!subscription) {
      return (
        <div className="no_plan_message">
          <p>No plans available at the moment.</p>
        </div>
      );
    }
    switch (subscription.subscriptionName) {
      case "Elite Trader":
        return (
          <div className="extrapre_upgradesec">
            <div className="pro_version_section">
              {eliteActive && (
                <div className="activated_tag_pro">Activated</div>
              )}
              <img
                src={ProImage}
                className="premium_imgcost"
                alt="Loading..."
              />
              <h5>{capitalizeFirstLetter(subscription.subscriptionName)}</h5>
              <p>Bots Strategies</p>
              <p className="free_intra">{subscription.Strategies}</p>
              <h1>
                {parseFloat(subscription.subscriptionAmount).toFixed(2)}
                <span className="currency_name">
                  {" "}
                  {subscription.subscriptionCurrency}
                </span>
                <span className="premium_cost">/month</span>
              </h1>
              <p className="free_tag" style={{ visibility: "hidden" }}>
                <span className="free_plan_pro">Free</span> for{" "}
                {subscription.subdays} Months{" "}
              </p>
              <div className="activate_btn_pro">
                <button
                  disabled={eliteActive}
                  onClick={() => handleShow("Promium", subscription)}
                >
                  Activate
                </button>
              </div>
              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pro">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pro">Exchanges:</span>{" "}
                    {capitalizeFirstLetter(subscription.Exchanges)}
                  </p>
                  {/* <p>{capitalizeFirstLetter(subscription.Exchanges)}</p> */}
                </div>
              </div>
              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pro">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                {/* <div className="free_details_list">
                  <p><span className="header_details_list_pro">Profit Split:</span> {subscription.SecondDistribution.user}(Users): {subscription.SecondDistribution.referral}(Referrals): {subscription.SecondDistribution.ipf}(IPF) + {subscription.SecondDistribution.admin}(Admins)</p>
                </div> */}
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pro">
                      Profit Split:
                    </span>
                    {/* {subscription.SecondDistribution.referral}(Referrals):{" "}
                    {subscription.SecondDistribution.ipf}(IPF) +{" "} */}
                    {subscription.SecondDistribution.user}(Users) +{" "}
                    {subscription.SecondDistribution.admin}(Admin)
                  </p>
                </div>
              </div>

              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pro">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pro">
                      Referral one time reward (
                      {subscription.subscriptionCurrency}):
                    </span>{" "}
                    {subscription.referral_first}
                  </p>
                </div>
              </div>

              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pro">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pro">
                      Referral reward for recurring payments (%):
                    </span>{" "}
                    {subscription.referral_percentage}
                  </p>
                </div>
              </div>

              {/* <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pro">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pro">
                      Own Account Use:
                    </span>{" "}
                    {capitalizeFirstLetter(subscription.OwnAccountUse)}
                  </p>
                </div>
              </div> */}
              {/* <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pro">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pro">
                      Minimum Balance Req To Trade:
                    </span>{" "}
                    {subscription.minbalancereq}
                  </p>
                </div>
              </div> */}
              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pro">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pro">
                      Minimum Fuel Balance Required:
                    </span>{" "}
                    {subscription.min_fuel}
                  </p>
                </div>
              </div>
              {/* <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pro">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pro">
                      Referral Withdrawal:
                    </span>{" "}
                    {capitalizeFirstLetter(subscription.Refferalwithdraw)}
                  </p>
                </div>
              </div>
              <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle_pro">
                    <i class="fa-solid fa-check"></i>
                  </span>
                </div>
                <div className="free_details_list">
                  <p>
                    <span className="header_details_list_pro">
                      Withdrawal Time For All User, Referral:
                    </span>{" "}
                    {capitalizeFirstLetter(
                      subscription.Withdrawtimeforallrefferaluser
                    )}
                  </p>
                </div>
              </div> */}
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div>
      <>
        <Header />
      </>

      <div className="withdraw-section">
        <div className="container">
          <div className="row prof_row_sm">
            <div className="col-lg-3 dispaly_none_1200">
              <Sidebar />
            </div>
            <div className="col-xl-9 col-lg-12 deposit_pad_top">
              <div className="upgrade_header">
                <h3 className="profile_span">
                  <span className="upgrade_text">{t("Upgrade")} </span>
                  <span className="upgrade_profilespan">
                    {t("YourProfile")}
                  </span>
                </h3>
                <p>{t("EmpowerYourTradingWithBinarge")}</p>
              </div>
              <div className="row mt-lg-1 mt-2 g-4 justify-content-center">
                {loading ? (
                  <div className="loader_main loader_mainChange">
                    <ScaleLoader color="#20A1FD" height={10} width={3} />
                    <p>{t("Loading")}</p>
                  </div>
                ) : (
                  <>
                    <div className="col-lg-5 ">
                      {getplan.map((subscription) => (
                        <SubscriptionCard
                          key={subscription._id}
                          subscription={subscription}
                          freemiumActive={freemiumActive}
                        />
                      ))}
                    </div>
                    <div className="col-lg-5 ">
                      {getplan.map((subscription) => (
                        <SubscriptionCardtwo
                          key={subscription._id}
                          subscription={subscription}
                          premiumActive={premiumActive}
                        />
                      ))}
                    </div>
                    <div className="col-lg-5 ">
                      {getplan.map((subscription) => (
                        <SubscriptionCardthree
                          key={subscription._id}
                          subscription={subscription}
                          promiumActive={promiumActive}
                        />
                      ))}
                    </div>
                    <div className="col-lg-5 ">
                      {getplan.map((subscription) => (
                        <SubscriptionCardfour
                          key={subscription._id}
                          subscription={subscription}
                          eliteActive={eliteActive}
                        />
                      ))}
                    </div>
                  </>
                )}
              </div>
              <Modal
                className="modal_section upgrade_modal_section"
                centered
                show={show}
                onHide={handleClose}
                animation={false}
              >
                <Modal.Header closeButton className="upgrad_modal_header">
                  <Modal.Title>{t("ConfirmPlanUpgrade")}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="upgrad_modal_body">
                  <div>
                    <h5
                      className={
                        premiumContent?.subscriptionName === "Premium"
                          ? "premium-header "
                          : premiumContent?.subscriptionName === "Promium"
                          ? "promium-header "
                          : "freemium-header "
                      }
                    >
                      {premiumContent?.subscriptionName}
                    </h5>
                    <p>
                      <strong className="stragte_head">
                        {t("BotsStrategies")}:
                      </strong>{" "}
                      {premiumContent?.Strategies}
                    </p>
                    <p className="upgrade_text_modal">
                      {t("UpgradingToThe")}{" "}
                      <strong
                        className={
                          premiumContent?.subscriptionName === "Premium"
                            ? "premium-header highlight_text_mod"
                            : premiumContent?.subscriptionName === "Promium"
                            ? "promium-header highlight_text_mod"
                            : "freemium-header highlight_text_mod"
                        }
                      >
                        {premiumContent?.subscriptionName}
                      </strong>{" "}
                      {t("PlanWillCostYou")}{" "}
                      <strong
                        className={
                          premiumContent?.subscriptionName === "Premium"
                            ? "premium-header highlight_text_mod"
                            : premiumContent?.subscriptionName === "Promium"
                            ? "promium-header highlight_text_mod"
                            : premiumContent?.subscriptionName === "Elite Trade"
                            ? "promium-header highlight_text_mod"
                            : "freemium-header highlight_text_mod"
                        }
                      >
                        {premiumContent?.subscriptionName === "Premium"
                          ? premiumContent?.free_status == "no"
                            ? "$" + premiumContent?.subscriptionAmount
                            : "Free"
                          : premiumContent?.subscriptionName === "Promium"
                          ? premiumContent?.free_status == "no"
                            ? "$" + premiumContent?.subscriptionAmount
                            : "Free"
                          : premiumContent?.subscriptionName === "Elite Trader"
                          ? premiumContent?.free_status == "no"
                            ? "$" + premiumContent?.subscriptionAmount
                            : "Free"
                          : "Free"}
                      </strong>
                      . {t("PleaseConfirmYourChoice")}
                    </p>
                    {discountCode ? (
                      <>
                        <div className="reg_inner_small">
                          <span className="register_spans upgrad_md_label">
                            {t("DiscountCode")}
                          </span>
                          <input
                            type="text"
                            name="email"
                            placeholder={t("EnterTheEmailAddress")}
                            className="reg_input"
                            value={discountCode}
                          />
                          <p className="upgrad_modal_content">
                            {t("GreatNews")} <strong>${discountAmount}</strong>.
                            {premiumContent ? (
                              <>
                                {" "}
                                {t("YouOnlyNeedToPay")}{" "}
                                <strong>
                                  $
                                  {premiumContent.subscriptionAmount -
                                    discountAmount}
                                </strong>{" "}
                                {t("forYourSubscription")}
                              </>
                            ) : (
                              <> {t("YourFinalPrice")}</>
                            )}
                          </p>
                        </div>
                        {/* <p className="upgrad_modal_content">
                      Great news! You've received a discount of <strong>${discountAmount}</strong>.
                      {premiumContent ? (
                        <> You only need to pay <strong>${premiumContent.subscriptionAmount - discountAmount}</strong> for your subscription.</>
                      ) : (
                        <> Your final price will be calculated once you select a plan.</>
                      )}
                    </p>  */}
                      </>
                    ) : (
                      ""
                    )}

                    {/* <h5 
          className={ premiumContent?.subscriptionName === "Premium"
                ? "premium-header mt-4"
                : premiumContent?.subscriptionName === "Promium"
                ? "promium-header mt-4"
                : "freemium-header mt-4" }>
                      {premiumContent?.subscriptionName}
                    </h5>
                    <p>
                      <strong className="stragte_head">Bots Strategies:</strong>{" "}
                      {premiumContent?.Strategies}
                    </p>
                    <p className="upgrade_text_modal">
                      Upgrading to the{" "}
                      <strong
                        className={
                          premiumContent?.subscriptionName === "Premium"
                            ? "premium-header highlight_text_mod"
                            : premiumContent?.subscriptionName === "Promium"
                            ? "promium-header highlight_text_mod"
                            : "freemium-header highlight_text_mod"
                        }
                      >
                        {premiumContent?.subscriptionName}
                      </strong>{" "}
                      plan will cost you{" "}
                      <strong
                        className={
                          premiumContent?.subscriptionName === "Premium"
                            ? "premium-header highlight_text_mod"
                            : premiumContent?.subscriptionName === "Promium"
                            ? "promium-header highlight_text_mod"
                            : premiumContent?.subscriptionName === "Elite Trade"
                            ? "promium-header highlight_text_mod"
                            : "freemium-header highlight_text_mod"
                        }
                      >
                        {premiumContent?.subscriptionName === "Premium"
                          ? premiumContent?.free_status == "no"
                            ? "$" + premiumContent?.subscriptionAmount
                            : "Free"

                          : premiumContent?.subscriptionName === "Promium"
                          ? premiumContent?.free_status == "no"
                            ? "$" + premiumContent?.subscriptionAmount : "Free"

                        : premiumContent?.subscriptionName === "Elite Trader"
                        ? premiumContent?.free_status == "no"
                          ? "$" + premiumContent?.subscriptionAmount
                            : "Free"
                            
                          : "Free"}
                      </strong>
                      . Please confirm your choice.
                    </p> */}
                  </div>
                </Modal.Body>

                <div className="upgrad_modal_footer upgradpad_modal_footer">
                  {premiumContent?.subscriptionName !== "Freemium" &&
                    (loading ? (
                      <Button variant="primary" className="upgrade_btn">
                        {t("Loading")}
                      </Button>
                    ) : (
                      <Button
                        variant="primary"
                        className="upgrade_btn"
                        onClick={() => FiatviaUpgrade(premiumContent)}
                      >
                        {t("FiatViaUpgrade")}
                      </Button>
                    ))}

                  {loading ? (
                    <Button variant="primary" className="upgrade_btn">
                      {t("Loading")}
                    </Button>
                  ) : (
                    <Button
                      variant="primary"
                      className="upgrade_btn"
                      onClick={() => PlanUpgrade(premiumContent)}
                    >
                      {premiumContent?.subscriptionName !== "Freemium"
                        ? "Crypto via Upgrade"
                        : "Confirm Upgrade"}
                    </Button>
                  )}
                </div>
              </Modal>
              <Modal
                className="modal_section upgrade_modal_section"
                centered
                show={fiatviashow}
                onHide={handleCloseFiat}
                animation={false}
              >
                <Modal.Header closeButton className="upgrad_modal_header">
                  <Modal.Title>{t("FiatViaPlanUpgrade")}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="upgrad_modal_body">
                  <div>
                    {/* <h5
                      className={
                        premiumContent?.subscriptionName === "Premium"
                          ? "premium-header "
                          : premiumContent?.subscriptionName === "Promium"
                          ? "promium-header "
                          : "freemium-header "
                      }
                    >
                      {premiumContent?.subscriptionName}
                    </h5> */}
                    <p className="plan_paddle_fiat">
                      <strong className="stragte_head ">
                        {t("SelectedPlan ")}
                      </strong>{" "}
                      {premiumContent?.subscriptionName}
                    </p>
                    {/* <p className="plan_paddle_fiat">
                      <strong className="stragte_head ">Bots Strategies</strong>{" "}
                      {premiumContent?.Strategies}
                    </p> */}
                    <div className="reg_inner_small currecy_fiat_pad">
                      <span className="register_spans currency_fiat_span">
                        {t("SelectCurrency")}
                      </span>
                      <Select
                        options={[
                          { value: "EUR", label: "EUR" },
                          { value: "USD", label: "USD" },
                          // { value: "TWD", label: "TWD" },
                          // { value: "THB", label: "THB" },
                          // { value: "CNY", label: "CNY" },
                          // { value: "SGD", label: "SGD" },
                        ]}
                        styles={customStyles}
                        placeholder={t("SelectCurrency")}
                        onChange={handleCurrencyChange}
                        className="withdraw-dropdown-menu withdraw-dropdown-menunew"
                      />
                    </div>
                    {selectedCurrency && selectedPriceId && (
                      <>
                        <p className="plan_paddle_fiat">
                          <strong className="stragte_head">{t("Cost")}</strong>{" "}
                          <p>{`${selectedCost ?? 0} ${
                            selectedCurrency ?? ""
                          }`}</p>
                        </p>
                        <p className="upgrade_text_modal">
                          {t("UpgradingToThe")}{" "}
                          <strong
                            className={
                              premiumContent?.subscriptionName === "Premium"
                                ? "premium-header highlight_text_mod"
                                : premiumContent?.subscriptionName === "Promium"
                                ? "promium-header highlight_text_mod"
                                : "freemium-header highlight_text_mod"
                            }
                          >
                            {premiumContent?.subscriptionName}
                          </strong>{" "}
                          {t("PlanWillCostYou")}{" "}
                          <strong
                            className={
                              premiumContent?.subscriptionName === "Premium"
                                ? "premium-header highlight_text_mod"
                                : premiumContent?.subscriptionName === "Promium"
                                ? "promium-header highlight_text_mod"
                                : premiumContent?.subscriptionName ===
                                  "Elite Trade"
                                ? "promium-header highlight_text_mod"
                                : "freemium-header highlight_text_mod"
                            }
                          >
                            {premiumContent?.subscriptionName === "Premium"
                              ? premiumContent?.free_status == "no"
                                ? `${selectedCost ?? 0} ${
                                    selectedCurrency ?? ""
                                  }`
                                : "Free"
                              : premiumContent?.subscriptionName === "Promium"
                              ? premiumContent?.free_status == "no"
                                ? `${selectedCost ?? 0} ${
                                    selectedCurrency ?? ""
                                  }`
                                : "Free"
                              : premiumContent?.subscriptionName ===
                                "Elite Trader"
                              ? premiumContent?.free_status == "no"
                                ? `${selectedCost ?? 0} ${
                                    selectedCurrency ?? ""
                                  }`
                                : "Free"
                              : "Free"}
                          </strong>
                          . {t("PleaseConfirmYourChoice")}
                        </p>
                      </>
                    )}
                  </div>
                </Modal.Body>

                <div className="upgrad_modal_footer upgradpad_modal_footer">
                  {loading == true ? (
                    <Button variant="primary" className="upgrade_btn">
                      {t("Loading")}
                    </Button>
                  ) : (
                    <Button
                      variant="primary"
                      className="upgrade_btn"
                      //   onClick={() => FiatviaUpgrade(premiumContent)}
                      onClick={() => ConfirmFiatUpgrade(premiumContent)}
                      //   onClick={() => PlanUpgrade(premiumContent)}
                    >
                      {t("ConfirmUpgrade")}
                    </Button>
                  )}
                </div>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Upgrade;
